module.exports = __webpack_public_path__ + "static/media/TATASTEEL.e60948e5.txt";